import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

import { isGamesTheme } from "@utils";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";
import PromoContentImage from "@components/icons/PromoContentImage";

export default function GamesMenuOption() {
	const { t } = useTranslation();

	const { handleGamesRedirection } = useGamesNavigation();

	if (isGamesTheme()) {
		return null;
	}

	if (!WEBPACK_IS_GAMES_ENABLED) {
		return null;
	}

	return (
		<div
			className="sidebar__section"
			onClick={() => handleGamesRedirection()}
		>
			<div className="sidebar__ad card">
				<PromoContentImage
					page="user-menu-options"
					wrapperClassName="sidebar__ad__picture"
					className="sidebar__ad__img"
					image="login-1.png"
					fallback="membership.png"
				/>

				<div className="sidebar__ad__header card__header">
					<ReactMarkdown>TIPWIN GAMES</ReactMarkdown>
				</div>

				<div className="sidebar__ad__body card__body u-padd--y--reset">
					<ReactMarkdown>
						{t("specific:INFO_PAGES.GAMES.DESCRIPTION")}
					</ReactMarkdown>
				</div>

				<div className="sidebar__ad__footer card__footer">
					<div className="sidebar__ad__btn btn btn--sml btn--block btn--secondary--inverted btn--icon">
						<span className="btn__label u-type--sml">
							{t("specific:INFO_PAGES.GAMES.PLAY_BUTTON")}
						</span>
						<i className="u-icon u-icon--tny u-icon--arrow-right u-color--core--snow" />
					</div>
				</div>
			</div>
		</div>
	);
}
